<script setup lang="ts">
import { computed } from 'vue'

/** A person's picture: their own if they set one, otherwise their initials. */
const props = withDefaults(
  defineProps<{
    name: string
    avatarUrl?: string | null
    size?: number
  }>(),
  { avatarUrl: null, size: 32 },
)

const initials = computed(() =>
  props.name
    .split(' ')
    .filter(Boolean)
    .slice(0, 2)
    .map((part) => part[0]?.toUpperCase() ?? '')
    .join(''),
)
</script>

<template>
  <span
    class="user-avatar"
    :style="{ width: `${size}px`, height: `${size}px`, fontSize: `${Math.round(size * 0.38)}px` }"
    aria-hidden="true"
  >
    <img v-if="avatarUrl" :src="avatarUrl" alt="" />
    <template v-else>{{ initials }}</template>
  </span>
</template>

<style scoped>
.user-avatar {
  display: inline-flex;
  flex: 0 0 auto;
  align-items: center;
  justify-content: center;
  overflow: hidden;
  border: 1px solid var(--line-on-field);
  border-radius: var(--radius-full);
  background: var(--surface-field-raised);
  color: inherit;
  font-weight: var(--font-weight-semibold);
}

.user-avatar img {
  width: 100%;
  height: 100%;
  object-fit: cover;
}
</style>
